import { render, staticRenderFns } from "./companyhonor.vue?vue&type=template&id=15f7461c&"
import script from "./companyhonor.vue?vue&type=script&lang=js&"
export * from "./companyhonor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports